require('./reimburseInvestmentStep2Content.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const {  FormattedText, formatText } = require('core/i18n').i18n;
// @ components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const ReimburseInvestmentDetails = require('components/hireInvestmentFunds/reimburseInvestmentDetails/reimburseInvestmentDetails');
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
// @ constants
const { BROKER_REIMBURSE_FUND_ID } = require('constants/operationTypes');

class ReimburseInvestmentStep2 extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const {
            immReimburseInvestment,
            operationParams,
            immFlagBasedFeatures
        } = this.props;
        return (
            <div className="reimburse-investment-step2">
                <FormattedText
                    value="brokerReimburseInvestmentStep2-title"
                    className="reimburse-investment-step2__title"
                />
                <ContactCenterRender>
                    <ConfirmationScript
                        operative={formatText("operatives-reimburseInvestment")}
                        confirmationType={CONFIRMATION_SCRIPT_GREETING}
                    />
                </ContactCenterRender>
                <FormattedText
                    value="brokerReimburseInvestmentStep2-description"
                    className="reimburse-investment-step2__description"
                />
                <ReimburseInvestmentDetails
                    immReimburseInvestment={immReimburseInvestment}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                />
                <ContactCenterRender>
                    <ConfirmationScript
                        confirmationType={CONFIRMATION_SCRIPT_AGREEMENT}
                    />
                </ContactCenterRender>
                <div className="hire-investment-step2__signature-container">
                    <SignaturePattern
                        operationType={BROKER_REIMBURSE_FUND_ID}
                        operationParams={operationParams}
                    />
                </div>
            </div>
        );
    }
}

ReimburseInvestmentStep2.propTypes = {
    immReimburseInvestment: PropTypes.object.isRequired,
    operationParams: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
};
module.exports = ReimburseInvestmentStep2;
